<mat-tab-group
  class="munily-tabs"
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="onSelectedIndexChange($event)"
  animationDuration="200ms"
>
  <mat-tab *ngFor="let tab of tabs" [disabled]="tab.disabled">
    <ng-template mat-tab-label>
      <div class="munily-tab-item" [class.munily-tab-item--disabled]="tab.disabled">
        <mat-icon
          *ngIf="tab.icon"
          class="material-symbols-rounded munily-tab-item__icon"
          aria-hidden="true"
        >{{ tab.icon }}</mat-icon>
        <span class="munily-tab-item__label">{{ tab.label }}</span>
        <app-badge
          *ngIf="showBadge && tab.badgeCount != null && tab.badgeCount > 0"
          [value]="tab.badgeCount"
          size="medium"
        ></app-badge>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
